import { render, staticRenderFns } from "./AddAnnouncementPopup.vue?vue&type=template&id=df9ded9a"
import script from "./AddAnnouncementPopup.vue?vue&type=script&lang=js"
export * from "./AddAnnouncementPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports